const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'accounts';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'accounts',
  STORED_ACCOUNTS: 'stored',
  ADD_ACCOUNT_LINK: 'add',
  ADD_ACCOUNT: 'add/:accountId/:lineId',
  DETAIL_ACCOUNT: ':accountId/:lineId/:isAccountStored',
  EDIT_ACCOUNT: 'edit/:accountId/:lineId',
  EDIT_ACCOUNT_LINK: 'edit',
  DUPLICATE_ACCOUNT: 'duplicate/:accountId/:lineId',
  DUPLICATE_ACCOUNT_LINK: 'duplicate',
  ADD_RENOVATION: 'add/renovation/:accountId/:lineId',
  ADD_RENOVATION_LINK: 'add/renovation',
  EDIT_RENOVATION: 'edit/renovation/:accountId/:lineId',
  EDIT_RENOVATION_LINK: 'edit/renovation',
  EDIT_ENDORSEMENT: 'edit/endorsement/:accountId/:lineId',
  EDIT_ENDORSEMENT_LINK: 'edit/endorsement',
  ADD_ENDORSEMENT: 'add/endorsement/:accountId/:lineId',
  ADD_ENDORSEMENT_LINK: 'add/endorsement',
  DETAIL_ENDORSEMENT: 'detail/endorsement/:accountId/:lineId',
  DETAIL_ENDORSEMENT_LINK: 'detail/endorsement',
  DETAIL_RENOVATION: 'detail/renovation/:accountId/:lineId',
  DETAIL_RENOVATION_LINK: 'detail/renovation',
};

export const generateFullModuleRoute = (route?: string): string => {
  if (route.length) {
    return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
  } else {
    return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}`;
  }
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Gestión de cuentas',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-list',
        route: generateFullModuleRoute(''),
        title: 'Cuentas',
        activated: true,
      },
      {
        icon: 'pi pi-inbox',
        route: generateFullModuleRoute('stored'),
        title: 'Archivadas',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.STORED_ACCOUNTS),
    title: 'Cuentas archivadas',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.ADD_ACCOUNT),
    title: 'Crear cotización',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETAIL_ACCOUNT),
    title: 'Detalle de la cotización',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDIT_ACCOUNT),
    title: 'Editar cotización',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DUPLICATE_ACCOUNT),
    title: 'Duplicar cuenta',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.ADD_RENOVATION),
    title: 'Crear renovación',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.ADD_ENDORSEMENT),
    title: 'Crear endoso',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDIT_RENOVATION),
    title: 'Editar renovación',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDIT_ENDORSEMENT),
    title: 'Editar endoso',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETAIL_ENDORSEMENT),
    title: 'Detalle endoso',
    activateRoute: generateFullModuleRoute(''),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETAIL_RENOVATION),
    title: 'Detalle renovación',
    activateRoute: generateFullModuleRoute(''),
  },
];

export const TIPO_COTIZACION_LINEAS_COMERCIALES = {
  PESOS: 'UYU',
  DOLARES: 'USD',
  EUROS: 'EUR',
};

export const ESTRATEGIAS_COMERCIALES = [
  { name: 'Target', value: 'Target' },
  { name: 'Cross Sell', value: 'CrossSell' },
  { name: 'Win Back', value: 'WinBack' },
];

export const ACTIVIDADES_SBI = [
  { name: 'Alimento', value: 'Alimento' },
  { name: 'Energía', value: 'Energía' },
  { name: 'Deporte', value: 'Deporte' },
];

export const ESTADOS = [
  { name: 'Bloqueada', value: 'Bloqueada' },
  { name: 'En Sección', value: 'EnSeccion' },
  { name: 'Prospecto', value: 'Prospecto' },
  { name: 'Cotizada', value: 'Cotizada' },
  { name: 'Ganada', value: 'Ganada' },
  { name: 'No Ganada', value: 'NoGanada' },
  { name: 'No Cotizada', value: 'NoCotizada' },
  { name: 'Declinada', value: 'Declinada' },
  { name: 'En Gestión', value: 'EnGestion' },
  { name: 'Renovada', value: 'Renovada' },
  { name: 'No Renovada', value: 'NoRenovada' },
  { name: 'Emitido', value: 'Emitido' },
  { name: 'En Gestión Renovacion', value: 'EnGestionRenovacion' },
  { name: 'No Recurrente', value: 'NoRecurrente' },
  { name: 'Aviso Enviado', value: 'AvisoEnviado' },
  { name: 'Extendida', value: 'Extendida' },
];

export const ACCOUNT_STORE_STATUS = {
  STORED: true,
  NOT_STORED: false,
};

export const DATA_ACCOUNT_TABS = {
  DATOS_CUENTA: 'datosCuenta',
  DOCUMENTOS_ADJUNTOS: 'documentosAdjuntos',
  COMENTARIOS: 'comentarios',
  MOVIMIENTOS_VINCULADOS: 'movimientosVinculados',
};

export const CLASIFICACION_DOCUMENTOS_COTIZACION = [
  { name: 'Formulario de alta', value: 'FormularioAlta' },
  { name: 'Inspecciones / Ingeniería', value: 'InspeccionesIngenieria' },
  { name: 'Cobranzas', value: 'Cobranzas' },
  { name: 'Documentos varios', value: 'DocumentosVarios' },
  { name: 'Póliza', value: 'Poliza' },
  { name: 'Mail de avisos', value: 'MailAvisos' },
  { name: 'Suscripción', value: 'Suscripcion' },
  { name: 'Certificados', value: 'Certificados' },
  { name: 'Reaseguros', value: 'Reaseguros' },
  { name: 'Siniestralidad', value: 'Siniestralidad' },
  { name: 'Control calidad', value: 'ControlCalidad' },
  { name: 'Solicitud de Cotización', value: 'SolicitudDeCotizacion' },
  { name: 'Cotización', value: 'Cotizacion' },
  { name: 'Cotización aceptada', value: 'CotizacionAceptada' },
  { name: 'Apetito de riesgo', value: 'ApetitoDeRiesgo' },
  { name: 'Confirmación de Emisión', value: 'ConfirmacionDeEmision' },
  { name: 'Subcomité Suscripción', value: 'SubcomiteSuscripcion' },
  { name: 'Formulario de suscripción', value: 'FormularioDeSuscripcion' },
  { name: 'Aviso de vencimiento', value: 'AvisoDeVencimiento' },
];

export const LIST_ACCOUNTS_COLUMNS_NAME = {
  COMENTARIOS: 'comments',
  MES_GESTION: 'mesGestion',
  NOMBRE_CUENTA: 'nombreCuenta',
  NOMBRE_COMERCIAL: 'nombreComercial',
  NRO_POLIZA: 'numeroPoliza',
  PRIMA: 'prima',
  ESTADO: 'estado',
  CORREDOR: 'corredor',
  EJECUTIVO_COMERCIAL: 'ejecutivoComercial',
  CODIGO_GIRO_COMERCIAL: 'codigoGiroComercial',
  SUBLINEA: 'sublinea',
  ULTIMA_MODIFICACION: 'ultimaModificacion',
  SUSCRIPTOR: 'nombreSuscriptor',
  TIPO_MOVIMIENTO: 'tipoDeCuenta',
  POLIZA_EXPIRANTE: 'polizaExpirante',
  ACTIONS: 'actions',
};

export const LIST_STORED_ACCOUNTS_COLUMNS_NAME = {
  COMENTARIOS: 'comments',
  MES_GESTION: 'mesGestion',
  NOMBRE_CUENTA: 'nombreCuenta',
  NOMBRE_COMERCIAL: 'nombreComercial',
  RAZON_SOCIAL: 'razonSocial',
  ESTRATEGIA_COMERCIAL: 'estrategiaComercial',
  CORREDOR: 'corredor',
  CODIGO_GIRO_COMERCIAL: 'codigoGiroComercial',
  SUBLINEA: 'sublinea',
  EJECUTIVO_COMERCIAL: 'ejecutivoComercial',
  PRIMA: 'prima',
  ESTADO: 'estado',
  ACTIONS: 'actions',
};

export const CONFIG_LISTADO = {
  LIST_ACCOUNTS: 'Administrador.GestionCuentas.ListadoCuentas',
  LIST_STORED_ACCOUNTS: 'Administrador.GestionCuentas.ListadoCuentasArchivadas',
};

export const ESTADOS_RENOVACIONES = [
  { name: 'En Gestión', value: 'EnGestion' },
  { name: 'Cotizada', value: 'Cotizada' },
  { name: 'No Ganada', value: 'NoGanada' },
  { name: 'Renovada', value: 'Renovada' },
  { name: 'No renovada', value: 'NoRenovada' },
  { name: 'No Recurrente', value: 'NoRecurrente' },
  { name: 'Aviso Enviado', value: 'AvisoEnviado' },
];

export const ESTADOS_RENOVACIONES_EDIT = [
  ...ESTADOS_RENOVACIONES,
  { name: 'Extendida', value: 'Extendida' },
];

export const ESTADOS_ENDOSOS = [
  { name: 'En Gestión', value: 'EnGestion' },
  { name: 'Emitido', value: 'Emitido' },
];

export const ESTADOS_ENDOSOS_DETAIL = [
  { name: 'En Gestión', value: 'EnGestion' },
  { name: 'Emitido', value: 'Emitido' },
  { name: 'No Renovada', value: 'NoRenovada' },
];

export const TIPO_CUENTA = {
  NuevaCotizacion: 'Nueva cotización',
  Endoso: 'Endoso',
  Renovacion: 'Renovación',
};

export const CLASSIFICATION_DROPDOWN_SETTINGS = {
  singleSelection: false,
  idField: 'value',
  textField: 'name',
  searchPlaceholderText: 'Buscar clasificación',
  selectAllText: 'Seleccionar todos',
  unSelectAllText: 'Deselecionar todos',
  itemsShowLimit: 2,
  allowSearchFilter: true,
};

export const CONFIG_LIST_ACCOUNTS = {
  ACCOUNT_LIST: 'Administrador.GestionCuentas.ListadoCuentas',
};

export const STATES_LIST_ACCOUNTS = [
  { name: 'Bloqueada', value: 'Bloqueada' },
  { name: 'En Sección', value: 'EnSeccion' },
  { name: 'Prospecto', value: 'Prospecto' },
  { name: 'Cotizada', value: 'Cotizada' },
  { name: 'Ganada', value: 'Ganada' },
  { name: 'No Ganada', value: 'NoGanada' },
  { name: 'No Cotizada', value: 'NoCotizada' },
  { name: 'Declinada', value: 'Declinada' },
  { name: 'En Gestión', value: 'EnGestion' },
  { name: 'Renovada', value: 'Renovada' },
  { name: 'No Renovada', value: 'NoRenovada' },
  { name: 'Emitido', value: 'Emitido' },
  { name: 'No Recurrente', value: 'NoRecurrente' },
  { name: 'Aviso Enviado', value: 'AvisoEnviado' },
  { name: 'Extendida', value: 'Extendida' },
];

export const ACCOUNT_TYPES_LIST_ACCOUNTS = [
  { name: 'Nueva cotización', value: 'Nueva cotización' },
  { name: 'Endoso', value: 'Endoso' },
  { name: 'Renovación', value: 'Renovación' },
];
